import { render } from "./ShowTesisY.vue?vue&type=template&id=49eae5e7&scoped=true"
import script from "./ShowTesisY.vue?vue&type=script&lang=js"
export * from "./ShowTesisY.vue?vue&type=script&lang=js"

import "./ShowTesisY.vue?vue&type=style&index=0&id=49eae5e7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49eae5e7"

export default script